export const formatCardLastFourDigits = (cardNumber, t) => {
  if (!cardNumber) return t('COMMON.PAYMENT_LINK');
  return `**** **** **** ${cardNumber}`;
};

export const formatCardBrand = brand => {
  return brand
    ? brand
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
    : '';
};
